import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import ContactEyeIcon from "../../assets/icons/ContentEyeIcon.svg";
import OpenEyeIcon from "../../assets/icons/OpenEyeIcon.svg";
import Close from "../../assets/icons/Close.svg";
import {
  setIsOpenModelEditAccountPassword,
  updateAccountPasswordList,
} from "../../redux/actions/accountAction";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const ChangepasswordModel = (Props) => {
  const dispatch = useDispatch();
  const isUserAccountPwdButtonLoading = useSelector(
    (state) => state?.user?.isUserAccountPwdButtonLoading
  );

  const EditUserAccountPasswordModel = useSelector(
    (state) => state?.account?.models?.EditUserAccountPasswordModel
  );

  const [showCurrentPassword, setShowCurrentPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const [UserAccountPasswordData, setUserAccountPasswordData] = useState({
    CurrentPassword: "",
    NewPassword: "",
    ConfirmPassword: "",
  });

  const handleChangeUserAccountPasswordData = (e) => {
    const { name, value } = e.target;
    setUserAccountPasswordData({ ...UserAccountPasswordData, [name]: value });
  };

  useEffect(() => {
    if (!EditUserAccountPasswordModel) {
      setUserAccountPasswordData({
        CurrentPassword: "",
        NewPassword: "",
        ConfirmPassword: "",
      });
    }
  }, [EditUserAccountPasswordModel]);

  const handleShowPassword = (field) => {
    switch (field) {
      case "currentPassword":
        setShowCurrentPassword(!showCurrentPassword);
        break;
      case "newPassword":
        setShowNewPassword(!showNewPassword);
        break;
      case "confirmPassword":
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };

  const handleSaveUserAccountPassword = async (event) => {
    event.preventDefault();
    if (
      UserAccountPasswordData?.CurrentPassword !== "" &&
      UserAccountPasswordData?.NewPassword !== "" &&
      UserAccountPasswordData?.ConfirmPassword !== ""
    ) {
      if (
        UserAccountPasswordData?.NewPassword ===
        UserAccountPasswordData?.ConfirmPassword
      ) {
        dispatch(
          updateAccountPasswordList({
            old_password: UserAccountPasswordData?.CurrentPassword,
            password: UserAccountPasswordData?.NewPassword,
            confirm_password: UserAccountPasswordData?.ConfirmPassword,
          })
        );
      } else {
        toast.error("Please enter new password and confirm password same.");
      }
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  return (
    <Modal
      open={EditUserAccountPasswordModel}
      onClose={() => dispatch(setIsOpenModelEditAccountPassword(false))}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Change Password
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => dispatch(setIsOpenModelEditAccountPassword(false))}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                type={showCurrentPassword ? "text" : "password"}
                placeholder="Current Password"
                name="CurrentPassword"
                value={UserAccountPasswordData?.CurrentPassword}
                onChange={handleChangeUserAccountPasswordData}
                sx={{
                  width: "100%",
                  borderRadius: "50px",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleShowPassword("currentPassword")}
                      >
                        <img
                          src={
                            showCurrentPassword ? OpenEyeIcon : ContactEyeIcon
                          }
                          alt="Eye Icon"
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                type={showNewPassword ? "text" : "password"}
                placeholder="New Password"
                name="NewPassword"
                value={UserAccountPasswordData?.NewPassword}
                onChange={handleChangeUserAccountPasswordData}
                sx={{
                  width: "100%",
                  borderRadius: "50px",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleShowPassword("newPassword")}
                      >
                        <img
                          src={showNewPassword ? OpenEyeIcon : ContactEyeIcon}
                          alt="Eye Icon"
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                name="ConfirmPassword"
                value={UserAccountPasswordData?.ConfirmPassword}
                onChange={handleChangeUserAccountPasswordData}
                sx={{
                  width: "100%",
                  borderRadius: "50px",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleShowPassword("confirmPassword")}
                      >
                        <img
                          src={
                            showConfirmPassword ? OpenEyeIcon : ContactEyeIcon
                          }
                          alt="Eye Icon"
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"

                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  // backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  // ":hover": {
                  //   backgroundColor: "#26875C",
                  // },
                }}
                onClick={() =>
                  dispatch(setIsOpenModelEditAccountPassword(false))
                }
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleSaveUserAccountPassword}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                loading={isUserAccountPwdButtonLoading}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ChangepasswordModel;
